import React, { Component } from 'react';
import Container from 'react-bootstrap/esm/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { MyGlobal, MyAlert } from '../GlobalContext';
import Moment from 'react-moment';
import 'moment-timezone';
import { Link } from 'react-router-dom'


export class ManifestsInProgress extends Component {
    static displayName = ManifestsInProgress.name;

    constructor(props) {
        super(props);
        this.state = { loading: false, alertMessage: "", manifestsInProgress: [], selectedCarrierName: "", carriers: [], selectedCarrierId:"" };
        this.history = props.history;

    }

    componentDidMount() {
        this.getCarriers();
    }
    goto(page) {
        this.history.push(page);
    }
    getCarriers() {
        this.setState({ loading: true, alertMessage: "" });

        fetch(`api/Manifest/GetWHCarrierDetailsForWIP?warehouseId=${MyGlobal.warehouse}`)
            .then(async response => {
                this.setState({ loading: false });
                // check for error response
                if (!response.ok) {
                    const errorText = await response.text();
                    console.error(errorText);
                    this.setState({ alertMessage: "Failed to load carriers!!" });
                }
                else {
                    const isJson = response.headers.get('content-type')?.includes('application/json');
                    const apiResponse = isJson ? await response.json() : null;
                    if (apiResponse) {
                        const data = apiResponse.data;
                        if (apiResponse.success) {
                            this.setState({ carriers: data });
                            if (data && data.length > 0) {
                                this.getManifestsInProgress(data[0].carrierId);
                                this.setState({ selectedCarrierName: data[0].carrierName, selectedCarrierId: data[0].carrierId });
                            }
                        }
                        else {
                            this.setState({ alertMessage: "Failed to load carriers!!  " + apiResponse.errorMessage });
                        }
                    }
                    else {
                        this.setState({ alertMessage: "Failed to load carriers!!" });
                    }
                }
            })
            .catch(error => {
                this.setState({ alertMessage: error });
            });
    }

    getManifestsInProgress(selectedCarrierId) {
        const selectedCarrier = this.state.carriers.find((element) => {
            return element.carrierId.toString() === selectedCarrierId.toString();
        });

        this.setState({ loading: true, alertMessage: "", selectedCarrierName: selectedCarrier.carrierName, selectedCarrierId: selectedCarrierId });
        fetch(`api/Manifest/GetManifestsInProgress?carrierId=${selectedCarrierId}&warehouseId=${MyGlobal.warehouse}`)
            .then(async response => {

                this.setState({ loading: false });
                // check for error response
                if (!response.ok) {
                    const errorText = await response.text();
                    console.error(errorText);
                    this.setState({ alertMessage: "Failed to load Manifests!!" });
                }
                else {
                    const isJson = response.headers.get('content-type')?.includes('application/json');
                    const apiResponse = isJson ? await response.json() : null;
                    if (apiResponse) {
                        const data = apiResponse.data;
                        if (apiResponse.success) {
                            this.setState({ manifestsInProgress: data });
                        }
                        else {
                            this.setState({ alertMessage: "Failed to load Manifests!!  " + apiResponse.errorMessage });
                        }
                    }
                    else {
                        this.setState({ alertMessage: "Failed to load Manifests!!" });
                    }
                }
            })
            .catch(error => {
                this.setState({ alertMessage: error });
            });
    }

    deleteTempManifest(tempManifestId, sessionId) {
        this.setState({ loading: true, alertMessage: "" });
        fetch(`api/Manifest/DeleteTempManifest?tempManifestId=${tempManifestId}&sessionId=${sessionId}`)
            .then(async response => {

                this.setState({ loading: false });
                // check for error response
                if (!response.ok) {
                    const errorText = await response.text();
                    console.error(errorText);
                    this.setState({ alertMessage: "Failed to Delete Temporary Manifest !!" });
                }
                else {
                    const isJson = response.headers.get('content-type')?.includes('application/json');
                    const apiResponse = isJson ? await response.json() : null;
                    if (apiResponse) {
                        if (apiResponse.success) {
                            this.setState({ alertMessage: "Successfully deleted Temporary Manifest" });
                            this.getManifestsInProgress(this.state.selectedCarrierId);
                        }
                        else {
                            this.setState({ alertMessage: "Failed to Delete Temporary Manifest!!  " + apiResponse.errorMessage });
                        }
                    }
                    else {
                        this.setState({ alertMessage: "Failed to Delete Temporary Manifest!!" });
                    }
                }
            })
            .catch(error => {
                this.setState({ alertMessage: error });
            });
    }

    render() {

        const pagination = paginationFactory({
            page: 2,
            sizePerPage: 5,
            lastPageText: '>>',
            firstPageText: '<<',
            nextPageText: '>',
            prePageText: '<',
            showTotal: true,
            alwaysShowAllBtns: true
        });

        let alertMessage = this.state.alertMessage;
        alertMessage = alertMessage != "" ? <MyAlert variant="danger">{alertMessage}</MyAlert> : "";

        const defaultSorted = [{
            dataField: 'CreatedDate',
            order: 'desc'
        }];
        const columns = [
  
            { dataField: 'sessionId', text: 'SessionId' },
            {
                dataField: 'createdDate',
                text: 'Created',
                formatter: (value, row) => {
                    return <Moment format="DD/MM/YYYY HH:mm" >
                        {value}
                    </Moment>
                },
                sort: true
            },
            {
                dataField: 'updatedDate',
                text: 'Updated',
                formatter: (value, row) => {
                    return <Moment format="DD/MM/YYYY HH:mm" >
                        {value}
                    </Moment>
                },
                sort: true
            },
            {
                dataField: "id",
                text: "",
                formatter: (value, row) => {
                    return <Link className="btn btn-success col-12 mb-2" to={{
                        pathname: "ResumeManifest",
                        state: {
                            Id: row.id,
                            SessionId: row.sessionId,
                            SelectedCarrierId: this.state.selectedCarrierId,
                            SelectedCarrierName: this.state.selectedCarrierName,

                        }
                    }}>Resume</Link>
                }
            },
            {
                dataField: "",
                text: "",
                formatter: (value, row) => {
                    return <button type="button" className="btn btn-success col-12 mb-2"
                        onClick={() => { this.deleteTempManifest(row.id, row.sessionId); }}>Delete</button>
                }
            }
        ];


        return <div className="container" >
            {this.state.loading && <div> <em>Loading ... </em></div>}

            <Container>
                <Row className="mb-3">
                    <Col xs={9}>
                        <h5>Manifests In Progress</h5>
                        {alertMessage}
                    </Col>
                    <Col xs={3}>
                        <Link className="btn btn-success col-12 mb-2" to={{ pathname: "Manifesting" }}>Back</Link>
                    </Col>
                </Row>

                <Row className="mb-3">
                    <Col xs={5}>
                        <label>Carrier Name :</label>
                    </Col>
                    <Col xs={7}>
                        {this.state.selectedCarrierName}
                    </Col>
                </Row>

                <Row className="mb-3">
                    <Col xs={5}>
                        <label>Select a Carrier :</label>
                    </Col>
                    <Col xs={7}>
                        <select className="form-select form-control" aria-label=".form-select-lg example"
                            onChange={(e) => {
                                this.getManifestsInProgress(e.target.value)
                            }} >
                            {this.state.carriers.map(row =>
                                <option key={row.carrierId} value={row.carrierId}>{row.carrierName}</option>
                            )}
                        </select>
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col xs={12}>
                        <BootstrapTable keyField='id' data={this.state.manifestsInProgress} columns={columns} pagination={pagination} defaultSorted={defaultSorted} />
                    </Col>
                </Row>
            </Container>
            <br />
        </div>
    }


}
